import styled from "styled-components";

export const Container = styled("div")`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;
  text-align: center;
  padding: 20px;
  flex: 1;

  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const ImageSuccess = styled("img")`
  height: 300px;
  display: flex;
  align-content: center;
  justify-content: center;
  object-fit: contain;
  margin: 0 auto;
`;

export const Content = styled("div")`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex:1;
`;

export const ConsentText = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
`
